/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {
    bool, func, string, object,  // shape,
} from 'prop-types';
import { withRouter } from 'react-router';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';

import AddressBookModalEnterprise from '../AddressBookV2/AddressBookModal';
import CalendarBuilder from '../Calendar/CalendarBuilder';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import PersonalizationForm from '../Personalization/PersonalizationForm';
import PmallPersonalization from '../PmallPersonalization/PmallPersonalization';
import QasAddressVerificationModal from '../QasAddressVerification/QasAddressVerificationModal';
import QasAddressVerificationModalV2 from '../QasAddressVerification/QasAddressVerificationModalV2';

import { getPresentationFamily } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getError, getOrderId, getWorkingRecipient } from '../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import getBrandPresentationFamily from '../../../../../../helpers/getBrandPresentationFamily';
import { useModalContext } from './modal-context';
import { clearOrderItemErrors } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Actions';
import { enterpriseDeleteItem } from '../../../../../../../state/ducks/MfeCheckout/ducks/Cart/ducks/DeleteItem/DeleteItem-Actions';
import { getFeatureFlags } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import { getShowValidatedAddressSuggestion } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { getOrderItemErrors } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Selector';
import { PERSONALIZATION } from '../../../../../../../state/utils/errorFeatureTypes';
import { removePmallItem, updatePmallImages } from '../../../../../../../state/ducks/Common/ducks/PmallPersonalization/PmallPersonalization-Actions';
import { getShowValidatedAddress } from '../../../../../../../state/ducks/MfeCheckout/ducks/CartItem/AddressQAS/AddressQAS-Selectors';

const styles = (theme) => ({
    cartThirdPartyModals: {
        padding: '0px',
    },
    modalContainer: {
        padding: '0',
        '&:focus': {
            outline: 'none',
        },
    },
    headerModalText: {
        textAlign: 'center',
        fontWeight: '700',
        margin: '15px 0px 15px 0px',
    },
    btnContinue: {
        textTransform: 'none',
        backgroundColor: theme.palette.buttonBackgroundColor,
        color: theme.palette.primary?.contrastText,
        fontSize: '0.95em !important',
        fontWeight: 'bold',
        margin: '10px auto',
        display: 'block',
        width: '240px',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.buttonBackgroundColorSecondary,
            color: theme.palette.primary?.contrastText,
        },
    },
    btnRemove: {
        textTransform: 'none',
        color: theme.palette.buttonBackgroundColor,
        border: `solid 1px ${theme.palette.buttonBackgroundColor}`,
        backgroundColor: theme.palette.white,
        fontSize: '1em',
        fontWeight: 'bold',
        margin: '10px auto',
        display: 'block',
        width: '240px',
        '&:hover, &:focus, &:active': {
            border: `solid 1px ${theme.palette.buttonBackgroundColorSecondary}`,
            color: theme.palette.buttonBackgroundColorSecondary,
            backgroundColor: theme.palette.white,
        },
    },
});

const ModalBuilder = ({
    callClearOrderItemErrors, callDeleteItem,
    callUpdatePmallImage, callRemovePmallItem,
    classes, featureFlags, history, pageType,
    showAddressValidation, showAddressValidationV2,
    orderItemErrors, ldClient,
}) => {
    const {
        addonOrderItemId,
        addressBookIsOpen,
        calendarModalIsOpen,
        itemCountriesProdDeliverable,
        itemDetailData,
        itemRecipientData,
        parentType,
        personalizationIsOpen,
        pmallIsOpen,
        refnum,
        recipientGreetingData,
        recipientRedirectTo,
        setAddressBookIsOpen,
        setAddonOrderItemId,
        setButtonTypeQAS,
        setCalendarModalOpen,
        setContextOpenRecipientForm,
        setItemCountriesProdDeliverable,
        setItemDetailData,
        setItemRecipientData,
        setPmallOpen,
        setPersonalizationOpen,
        setRefnum,
        setRecipientGreetingData,
        setWrapperModalOpen,
        wrapperModalIsOpen,
        contextUserState,
    } = useModalContext();

    const orderItemError = orderItemErrors?.[itemDetailData?.cartItemId]?.recipient?.errorMessage || '';
    const itemZipCode = itemDetailData?.deliveryInfo?.zipCode?.trim() ? (itemRecipientData?.zipCode || itemDetailData?.deliveryInfo?.zipCode) : '00000';
    const cartItemId = itemDetailData?.cartItemId || addonOrderItemId;
    const skuCode = itemDetailData?.product?.productCode;
    const parentSkuCode = itemDetailData?.product?.parentProductCode;
    const productBrandId = itemDetailData?.product?.brandCode;
    const brandPresentationFamily = getBrandPresentationFamily(productBrandId);
    const isCheckoutUsingQASV2 = featureFlags['is-checkout-using-qas-v2'];
    const cartLabel = featureFlags['cart-icon-label']?.label || 'Cart';

    let QasAddressVerificationModalComponent = QasAddressVerificationModal;
    let showAddressValidationValue = showAddressValidation;

    if (isCheckoutUsingQASV2) {
        QasAddressVerificationModalComponent = QasAddressVerificationModalV2;
        showAddressValidationValue = showAddressValidationV2;
    }

    const closeDeliveryDateModal = () => {
        setCalendarModalOpen(false);
    };

    const closePersonalizationModal = () => {
        setPersonalizationOpen(false);
        setItemDetailData({});
        callClearOrderItemErrors(
            cartItemId,
            PERSONALIZATION,
            {
                errType: 'clearAllFields',
                field: '',
            },
        );
    };

    useEffect(() => {
        if (cartItemId) {
            callClearOrderItemErrors(
                cartItemId,
                PERSONALIZATION,
                {
                    errType: 'clearAllFields',
                    field: '',
                },
            );
        }
    }, [cartItemId]);

    const closePmallModal = () => {
        setItemDetailData({});
        setRefnum(null);
        callUpdatePmallImage();
        callRemovePmallItem();
        setPmallOpen(false);
    };

    const handleCloseAddressBook = (event, reason) => {
        if (reason !== 'backdropClick') {
            if (reason?.entryId) {
                setItemRecipientData({
                    ...itemRecipientData,
                    entryId: reason.entryId,
                    addressBookRecipientId: reason.addressBookRecipientId,
                });
            }

            setItemCountriesProdDeliverable([]);
            callClearOrderItemErrors(
                cartItemId,
                PERSONALIZATION,
                {
                    errType: 'clearAllFields',
                    field: '',
                },
            );
            callClearOrderItemErrors(
                cartItemId,
                'recipient',
                {
                    errType: 'clearAllFields',
                    field: '',
                },
            );
            setAddressBookIsOpen(false);
        }
    };

    // Handle remove addons and product
    const handleRemoveItem = () => {
        const isPassport = !!(itemDetailData?.product?.isPassport || itemDetailData?.isPassport);
        callDeleteItem(cartItemId, isPassport, history, pageType, 0, skuCode, parentSkuCode);
        setWrapperModalOpen(false);
        setItemDetailData({});
        setAddonOrderItemId(null);
    };

    const getModalContent = () => (
        <div className={classes.modalContainer}>
            <div className={classes.headerModalText}>Remove item from Shopping {cartLabel}?</div>
            <Button
                id="btn-continue"
                data-test="cart-btn-continue"
                name="continueButton"
                className={classes.btnContinue}
                aria-label="No, Continue Checkout"
                onClick={() => { setWrapperModalOpen(false); }}
            >
                No, Continue Checkout
            </Button>
            <Button
                id="btn-confirm-remove"
                data-test="cart-btn-confirm-remove"
                data-testid="cart-btn-confirm-remove"
                name="confirmRemoveItemButton"
                className={classes.btnRemove}
                aria-label="Yes, Remove Item"
                onClick={() => handleRemoveItem()}
            >
                Yes, Remove Item
            </Button>
        </div>
    );

    return (
        <>
            <ModalWrapper
                modalTitle="Remove Item"
                modalContent={getModalContent(classes)}
                isOpen={wrapperModalIsOpen}
                onCloseModal={() => setWrapperModalOpen(false)}
                btnClose={false}
            />
            {
                (itemZipCode && calendarModalIsOpen)
                    ? (
                        <CalendarBuilder
                            openCalendar={calendarModalIsOpen}
                            brandPresentationFamily={brandPresentationFamily}
                            deliveryDate={itemDetailData?.deliveryInfo?.deliveryDate || ''}
                            deliveryTextData={{
                                deliveryHeaderTitle: 'Delivery Calendar',
                                deliveryHeaderCaption: 'Select a delivery range below then click "Apply Date" to save your selection',
                            }}
                            orderDetails={itemDetailData}
                            zipCode={itemZipCode}
                            handleDeliveryCalendarClose={closeDeliveryDateModal}
                            pageProcess={pageType}
                            contextUserState={contextUserState}
                            itemRecipientData={itemRecipientData}
                            ldClient={ldClient}
                            productBrandId={productBrandId}
                        />
                    )
                    : null
            }
            {
                personalizationIsOpen && (
                    <ModalWrapper
                        modalTitle="Edit Personalization"
                        modalContent={(
                            <PersonalizationForm
                                orderItem={itemDetailData}
                                onCloseModal={closePersonalizationModal}
                            />
                        )}
                        isOpen={personalizationIsOpen}
                        onCloseModal={() => closePersonalizationModal()}
                        btnClose
                        alignItem="left"
                        modalSize="xs"
                    />
                )
            }
            {
                refnum && pmallIsOpen && (
                    <PmallPersonalization
                        isOpen={pmallIsOpen}
                        cartItemId={cartItemId}
                        sku={skuCode}
                        refnumCheckout={refnum}
                        handleModalPmall={closePmallModal}
                        pageType={pageType}
                        orderItem={itemDetailData}
                    />
                )
            }
            {
                addressBookIsOpen && (
                    <AddressBookModalEnterprise
                        addressBookIsOpen={addressBookIsOpen}
                        orderItem={itemDetailData}
                        pageType={pageType}
                        handleCloseAddressBook={handleCloseAddressBook}
                        itemCountriesProdDeliverable={itemCountriesProdDeliverable}
                    />
                )
            }
            {
                showAddressValidationValue
                && itemRecipientData.firstName
                && setItemRecipientData
                && (
                    <QasAddressVerificationModalComponent
                        handleCloseAddressBook={handleCloseAddressBook}
                        orderItem={itemDetailData}
                        pageType={pageType}
                        parentType={parentType}
                        setItemRecipientData={setItemRecipientData}
                        recipientGreetingData={recipientGreetingData}
                        recipientQASData={itemRecipientData}
                        recipientRedirectTo={recipientRedirectTo}
                        setButtonTypeQAS={setButtonTypeQAS}
                        setContextOpenRecipientForm={setContextOpenRecipientForm}
                        setRecipientGreetingData={setRecipientGreetingData}
                        orderItemError={orderItemError}
                    />
                )
            }
        </>
    );
};

ModalBuilder.propTypes = {
    classes: object.isRequired,
    callClearOrderItemErrors: func.isRequired,
    callDeleteItem: func.isRequired,
    callUpdatePmallImage: func.isRequired,
    callRemovePmallItem: func.isRequired,
    featureFlags: object.isRequired,
    history: object,
    pageType: string,
    showAddressValidation: bool.isRequired,
    showAddressValidationV2: bool.isRequired,
    orderItemErrors: object,
    ldClient: object,
};

ModalBuilder.defaultProps = {
    history: {},
    pageType: '',
    orderItemErrors: {},
    ldClient: null,
};

const mapStateToProps = (state) => ({
    currentWorkingItem: getWorkingRecipient(state),
    featureFlags: getFeatureFlags(state),
    error: getError(state),
    orderId: getOrderId(state),
    orderItemErrors: getOrderItemErrors(state),
    presentation_family: getPresentationFamily(state),
    showAddressValidation: getShowValidatedAddressSuggestion(state),
    showAddressValidationV2: getShowValidatedAddress(state),
});

const mapDispatchToProps = (dispatch) => ({
    callClearOrderItemErrors: bindActionCreators(clearOrderItemErrors, dispatch),
    callDeleteItem: bindActionCreators(enterpriseDeleteItem, dispatch),
    callRemovePmallItem: bindActionCreators(removePmallItem, dispatch),
    callUpdatePmallImage: bindActionCreators(updatePmallImages, dispatch),
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
)(ModalBuilder);
